<div class="col-12 grid my-auto">
  <i class="pi pi-times-circle mr-2" style="font-size: 2rem"></i>
  <span class="my-auto">
    {{config.data.message}}
  </span>
</div>
